<template>
  <div class="top-nav">
    <ul class="nav-container">
      <li class="nav-item" @click="event_changeTab(1)">未使用({{unUseCount}})</li>
      <li class="nav-item" @click="event_changeTab(2)">已使用({{usedCount}})</li>
      <li class="nav-item" @click="event_changeTab(3)">已失效({{expireCount}})</li>
    </ul>
    <div class="line" :style="lineStyle">
      <div class="inner"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MNav',
  props: {
    ticketType: {
      type: Number,
      default: 1
    },
    unUseCount: {
      type: Number,
      default: 0
    },
    usedCount: {
      type: Number,
      default: 0
    },
    expireCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    lineStyle() {
      const ticketType = this.ticketType
      return {
        transform: `translateX(${100 * (ticketType - 1)}%)`
      }
    }
  },
  methods: {
    event_changeTab(index) {
      this.$emit('emit_changeTab', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.top-nav {
  height: toRem(84);
  padding: 0 toRem(30);
  .nav-container {
    display: flex;
    justify-content: space-around;
    .nav-item {
      flex: 1;
      padding: toRem(15) 0 toRem(20);
      text-align: center;
      font-size: toRem(30);
      line-height: toRem(42);
      font-weight: 700;
    }
  }
  .line {
    width: 33.333%;
    height: toRem(6);
    transition: all ease 0.2s;
    .inner {
      width: toRem(60);
      height: 100%;
      background-color: #f8a120;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MNav/index.vue